module.exports = {
  /**
   * 系统名称
   */
  title: '河南省劳动关系权益保障联动平台',

  /**
   * 系统版本
   */
  version: 'v1.0.0',

  /**
   * 预览地址（开发环境）
   * https://qybzldpt.zeda.com.cn  --对外映射
   * http://192.168.9.56  --测试环境
   */
  // theZcBookPreviewUrl: process.env.VUE_APP_BASE_API == '/dev-api' ? 'http://192.168.9.110:1002' : 'https://192.168.9.55:8082/prod-api',
  // theJcBookPreviewUrl: process.env.VUE_APP_BASE_API == '/dev-api' ? 'http://192.168.9.110:1001' : 'https://192.168.9.55:8081/prod-api',
  // theRedirectBookPreviewUrl: process.env.VUE_APP_BASE_API == '/dev-api' ? 'http://localhost' : 'https://192.168.9.55',    //  'https://qybzldpt.zeda.com.cn' 55  http://192.168.9.56

  /**
   * 预览地址（生产环境）
   */
  theZcBookPreviewUrl: 'https://qybz.hrss.henan.gov.cn:8082/prod-api', // 切换为仲裁生产环境地址：https://qybz.hrss.henan.gov.cn:8082/prod-api
  theJcBookPreviewUrl: 'https://qybz.hrss.henan.gov.cn:8081/prod-api', // 切换为监察生产环境地址：https://qybz.hrss.henan.gov.cn:8081/prod-api
  theRedirectBookPreviewUrl: 'https://qybz.hrss.henan.gov.cn', // 切换为生产环境地址：https://qybz.hrss.henan.gov.cn
  // https://qybz.hrss.henan.gov.cn

  // 工商接口 根据公司名称获取统一信用代码
  theBusinessUrl: 'https://qybz.hrss.henan.gov.cn:8092/prod-api',

  // 门户首页默认版本 可选值 theBasic 简洁版   theColorful  色彩版
  websiteDefaultVersion: 'theBasic'
}
